import { ButtonDS, GlobalIcon, Typography, useDevice } from 'get-life-storybook-ts'
import { useContext, useEffect, useMemo } from 'react'
import { I18nContext } from '../../context/i18n.context'
import { getMessage } from '../StepsCalculatorPage/Components/PaymentGateway/components/PaymentCardContent/PaymentCardContent.component'
import "./MaxCapital.scss"
import { GetlifeContext } from '../../context/GetLifeContext.context'
import { CALENDAR_MEET } from '../../constants/Global'
import { trackCta } from '../../helpers/Tracking'

const MaxCapital = () => {
    const { state: { translate } } = useContext(I18nContext)
    const { setProgressBar } = useContext(GetlifeContext)
    const { isMobile } = useDevice()

    const disabledProgressBar = useMemo(() => {
        return false;
    }, []);

    useEffect(() => {
        setProgressBar(disabledProgressBar)
    }, [disabledProgressBar])

    return <div className='telesubscription'>
        <section className='telesubscription__section__first'>
            <GlobalIcon
                iconName="SearchIlustrationIcon"
                size={isMobile ? "IM" : "IL"}
            />
        </section>
        <section className='telesubscription__section__second'>
            <div className='telesubscription__section__second--text'>
                <Typography variant='H1' weight='700' text={translate("maxCapital.title")} color='purple' className='telesubscription__section__second--text--title' />
                <Typography variant='Body' text={translate("maxCapital.parragraph.first")} />
                <Typography variant='Body' text="">
                    {getMessage({ message: translate("maxCapital.parragraph.second"), replace: <b>{translate("maxCapital.parragraph.bold")}</b> })}
                </Typography>
            </div>

            <div className='telesubscription__section__second--buttons'>
                <ButtonDS
                    buttonType='primary'
                    leftIcon="CalendarEventLineIcon"
                    label={translate("maxCapital.button.calendar")}
                    onClick={() => {
                      trackCta('meeting')
                      window.open(CALENDAR_MEET)
                    }}
                    className='w-full'
                />
                <ButtonDS
                    buttonType='secondary'
                    leftIcon='PhoneIcon'
                    label={translate("maxCapital.button.phone").replace("$", `${process.env.REACT_APP_TEL_TELESUBSCRIPTION}`)}
                    onClick={() => window.location.href = `tel:${process.env.REACT_APP_TEL_TELESUBSCRIPTION}`}
                    className='w-full'
                />
            </div>
        </section>

    </div>
}

export default MaxCapital